import React, { useState } from 'react';
import axios from 'axios';
import { API_URL } from '../config/api';
import './CadastroEquipamento.css';

const CadastroEquipamento = ({ onEquipamentoAdded }) => {
  const [formData, setFormData] = useState({
    ip: '',
    endereco: '',
    numero: '',
    patrimonio: '',
    latitude: '',
    longitude: '',
    descricao_mk: '',
    bairro: '',
    server_name: '',
    ad_enabled: false,
    ad_image_url: '',
    ad_click_url: '',
    ad_delay_seconds: 5,
    session_timeout_minutes: 30
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      if (!formData.ip || !formData.ip.trim()) {
        setError('O campo IP é obrigatório.');
        setLoading(false);
        return;
      }

      if (!formData.endereco || !formData.endereco.trim()) {
        setError('O campo Endereço é obrigatório.');
        setLoading(false);
        return;
      }

      const dataToSend = { ...formData };

      for (const key in dataToSend) {
        if (dataToSend[key] === '') {
          dataToSend[key] = null;
        }
      }

      if (dataToSend.latitude !== null && dataToSend.latitude !== '' && dataToSend.latitude !== undefined) {
        const latStr = String(dataToSend.latitude).trim().replace(',', '.');
        if (latStr !== '') {
          const lat = parseFloat(latStr);
          if (isNaN(lat)) {
            setError('Latitude inválida. Digite um número válido (ex: -22.7306).');
            setLoading(false);
            return;
          }
          if (lat < -90 || lat > 90) {
            setError('Latitude inválida. Deve ser um número entre -90 e 90.');
            setLoading(false);
            return;
          }
          dataToSend.latitude = lat;
        } else {
          dataToSend.latitude = null;
        }
      } else {
        dataToSend.latitude = null;
      }

      if (dataToSend.longitude !== null && dataToSend.longitude !== '' && dataToSend.longitude !== undefined) {
        const lngStr = String(dataToSend.longitude).trim().replace(',', '.');
        if (lngStr !== '') {
          const lng = parseFloat(lngStr);
          if (isNaN(lng)) {
            setError('Longitude inválida. Digite um número válido (ex: -45.1247).');
            setLoading(false);
            return;
          }
          if (lng < -180 || lng > 180) {
            setError('Longitude inválida. Deve ser um número entre -180 e 180.');
            setLoading(false);
            return;
          }
          dataToSend.longitude = lng;
        } else {
          dataToSend.longitude = null;
        }
      } else {
        dataToSend.longitude = null;
      }

      if (dataToSend.ip) dataToSend.ip = dataToSend.ip.trim();
      if (dataToSend.endereco) dataToSend.endereco = dataToSend.endereco.trim();
      if (dataToSend.numero) dataToSend.numero = dataToSend.numero.trim();
      if (dataToSend.patrimonio) dataToSend.patrimonio = dataToSend.patrimonio.trim();
      if (dataToSend.descricao_mk) dataToSend.descricao_mk = dataToSend.descricao_mk.trim();
      if (dataToSend.bairro) dataToSend.bairro = dataToSend.bairro.trim();
      if (dataToSend.server_name) dataToSend.server_name = dataToSend.server_name.trim();
      if (dataToSend.ad_image_url) dataToSend.ad_image_url = dataToSend.ad_image_url.trim();
      if (dataToSend.ad_click_url) dataToSend.ad_click_url = dataToSend.ad_click_url.trim();

      dataToSend.ad_delay_seconds = Number.isFinite(Number(dataToSend.ad_delay_seconds))
        ? Number(dataToSend.ad_delay_seconds)
        : 5;
      dataToSend.session_timeout_minutes = Number.isFinite(Number(dataToSend.session_timeout_minutes))
        ? Number(dataToSend.session_timeout_minutes)
        : 30;

      const token = localStorage.getItem('token');
      if (!token) {
        setError('Sessão expirada. Faça login novamente.');
        setLoading(false);
        setTimeout(() => {
          window.location.href = '/sysconect/adm-login';
        }, 2000);
        return;
      }

      const response = await axios.post(
        `${API_URL}/api/equipamentos`,
        dataToSend,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.data) {
        setSuccess('Equipamento cadastrado com sucesso!');
        setFormData({
          ip: '',
          endereco: '',
          numero: '',
          patrimonio: '',
          latitude: '',
          longitude: '',
          descricao_mk: '',
          bairro: '',
          server_name: '',
          ad_enabled: false,
          ad_image_url: '',
          ad_click_url: '',
          ad_delay_seconds: 5,
          session_timeout_minutes: 30
        });
        if (onEquipamentoAdded) {
          onEquipamentoAdded();
        }
      }
    } catch (error) {
      console.error('Erro ao cadastrar equipamento:', error);

      if (error.response) {
        if (error.response.status === 401 || error.response.status === 403) {
          setError('Sessão expirada. Faça login novamente.');
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          setTimeout(() => {
            window.location.href = '/sysconect/adm-login';
          }, 2000);
        } else {
          setError(error.response.data?.error || `Erro ${error.response.status}: ${error.response.statusText}`);
        }
      } else if (error.request) {
        setError('Erro de conexão. Verifique sua internet e tente novamente.');
      } else {
        setError(error.message || 'Erro ao cadastrar equipamento. Tente novamente.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cadastro-equipamento">
      <div className="cadastro-header">
        <h1>Cadastrar Equipamento</h1>
        <p>Preencha os dados do equipamento Mikrotik</p>
      </div>

      <div className="cadastro-form-container">
        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}

        <form onSubmit={handleSubmit} className="cadastro-form">
          <div className="form-row">
            <div className="form-group">
              <label>IP *</label>
              <input
                type="text"
                name="ip"
                value={formData.ip}
                onChange={handleChange}
                required
                placeholder="192.168.1.1"
              />
            </div>

            <div className="form-group">
              <label>Endereço *</label>
              <input
                type="text"
                name="endereco"
                value={formData.endereco || ''}
                onChange={handleChange}
                required
                placeholder="Endereço completo"
                autoComplete="street-address"
                aria-label="Endereço"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Número</label>
              <input
                type="text"
                name="numero"
                value={formData.numero}
                onChange={handleChange}
                placeholder="123"
              />
            </div>

            <div className="form-group">
              <label>Patrimônio</label>
              <input
                type="text"
                name="patrimonio"
                value={formData.patrimonio}
                onChange={handleChange}
                placeholder="Patrimônio do equipamento"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Bairro</label>
              <input
                type="text"
                name="bairro"
                value={formData.bairro}
                onChange={handleChange}
                placeholder="Nome do bairro"
              />
            </div>

          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Latitude</label>
              <input
                type="text"
                inputMode="decimal"
                name="latitude"
                value={formData.latitude}
                onChange={handleChange}
                placeholder="-22.7306"
              />
              <small style={{ color: '#666', fontSize: '0.85em', display: 'block', marginTop: '4px' }}>
                Exemplo: -22.7306 (Lorena, SP)
              </small>
            </div>

            <div className="form-group">
              <label>Longitude</label>
              <input
                type="text"
                inputMode="decimal"
                name="longitude"
                value={formData.longitude}
                onChange={handleChange}
                placeholder="-45.1247"
              />
              <small style={{ color: '#666', fontSize: '0.85em', display: 'block', marginTop: '4px' }}>
                Exemplo: -45.1247 (Lorena, SP)
              </small>
            </div>
          </div>

          <div className="form-group">
            <label>Descrição do MK</label>
            <textarea
              name="descricao_mk"
              value={formData.descricao_mk}
              onChange={handleChange}
              rows="3"
              placeholder="Descrição do equipamento Mikrotik"
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Server Name (Hotspot)</label>
              <input
                type="text"
                name="server_name"
                value={formData.server_name}
                onChange={handleChange}
                placeholder="hotspot1"
              />
            </div>
            <div className="form-group">
              <label>Tempo de Sessão (min)</label>
              <input
                type="number"
                min="1"
                name="session_timeout_minutes"
                value={formData.session_timeout_minutes}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-group">
            <label className="checkbox-row">
              <input
                type="checkbox"
                name="ad_enabled"
                checked={formData.ad_enabled}
                onChange={handleChange}
              />
              Ativar propaganda para este equipamento
            </label>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>URL da Imagem</label>
              <input
                type="text"
                name="ad_image_url"
                value={formData.ad_image_url}
                onChange={handleChange}
                placeholder="https://..."
              />
            </div>
            <div className="form-group">
              <label>URL de Clique</label>
              <input
                type="text"
                name="ad_click_url"
                value={formData.ad_click_url}
                onChange={handleChange}
                placeholder="https://..."
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Tempo para Fechar (s)</label>
              <input
                type="number"
                min="1"
                name="ad_delay_seconds"
                value={formData.ad_delay_seconds}
                onChange={handleChange}
              />
            </div>
          </div>

          <button type="submit" disabled={loading} className="submit-btn">
            {loading ? 'Cadastrando...' : 'Cadastrar Equipamento'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CadastroEquipamento;
